export const french = {
  language: "french",

  indexTitle: "Bowling Val Thorens",
  metaDescription:
    "Au coeur de la station de Val Thorens, venez decouvrir les pistes de bowling, la salle de jeux et les matchs de sport en live. ",

  welcome: "Accueil",
  reservation: "Réserver",
  activities: "Activitées",
  pool: "Billards",
  gameRoom: "Salle de Jeux",

  introText1:
    "Au coeur de la station de Val Thorens, venez decouvrir les différentes activités que vous propose le Bowling de Val Thorens. ",
  introText2: `Le Sport's bar 'la Bicicleta' met à votre disposition 8 écrans (jusqu'à 120") et retransmet en "live" tous les évènements sportifs importants, et au sous-sol vous trouvez une grande salle de jeux.`,
  openingHours: "Ouvert tous les jours de 16h à 2h et les samedis de 10h à 2h.",

  saturday: "Samedi",
  sunday: "Dimanche",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",

  jan: "Janv",
  feb: "Fevr",
  mar: "Mars",
  apr: "Avril",
  may: "Mai",
  june: "Juin",
  july: "Juil",
  aug: "Aout",
  sept: "Sept",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",

  nextWeek: "Prochaine",
  lastWeek: "Precedante",

  weekProgram: "programme de la semaine",

  activity1Description1:
    "A votre disposition, 8 pistes de bowling ultra modernes et homologuées QUBICA AMF.",
  activity1Description2:
    "La nuit, les pistes se dévoilent sous une ambiance fluo. Convivialité assurée !",
  activity1Description3:
    "Toutes les pistes sont équipées de barrières pour enfant.",
  activity1Price1: "1 partie de bowling	- 13,00 € / personne",
  activity1Price2: "2 parties de bowling	- 20,00 € / personne",

  activity2Description1:
    "Tous les jours de l'hiver, les plus beaux événements sportifs sont retransmis en 'live'.",
  activity2Description2:
    "Confort assuré au sport's bar 'La Bicicleta' grace aux multiples écrans. Rien d'impossible à 'La Bicicleta'. La technologie moderne des équipements vous permettra de visionner jusqu'à 4 évènement sportif en simultané...",
  activity2Description3: "Tous les lundis mojito party - mojito à 8€",

  activity3Description1:
    "Une grande variété de billards pour autant de plaisir s'offrent à vous dans nos deux salles de billards.",
  activity3Description2: "5 pool anglais (8 ball) de 7 feet",
  activity3Description3: "3 américain de 9 feet",
  activity3Price1: "1 partie de billards	- 4,00 €",
  activity3Price2: "6 parties de billards	- 20,00 €",

  activity4Description1: "De nombreaux jeux sont à votre disposition :",
  activity4Description2: "air hockey - babyfoot - street basket",
  activity4Description3: "jeux vidéos - jeux de course",

  instaTitle: "DERNIERES ACTUS",
  contactTitle: "VENIR AU BOWLING",

  cookieHeader: "NOUS RESPECTONS VOTRE VIE PRIVEE!",
  cookieText: "Ce site web utilise des cookies pour analyser notre trafic.",
  cookieAccept: "J'accepte !",
  cookieDecline: "Je refuse..",

  rights: "Tous droits réservés",
  legal: "Mentions légales",
};
